var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BYOCWrapper, fetchBYOCComponentServerProps, } from '@sitecore-jss/sitecore-jss-react';
import { constants } from '@sitecore-jss/sitecore-jss';
/**
 * This is a repackaged version of the React BYOCWrapper component with support for
 * server rendering in Next.js (using component-level data-fetching feature of JSS).
 */
/**
 * Will be called during SSG
 * @param {ComponentRendering} rendering
 * @returns {GetStaticPropsContext} context
 */
export const getStaticProps = (rendering) => __awaiter(void 0, void 0, void 0, function* () {
    if (process.env.JSS_MODE === constants.JSS_MODE.DISCONNECTED) {
        return null;
    }
    const params = rendering.params || {};
    const result = yield fetchBYOCComponentServerProps(params);
    return result;
});
/**
 * Will be called during SSR
 * @param {ComponentRendering} rendering
 * @returns {GetStaticPropsContext} context
 */
export const getServerSideProps = (rendering) => __awaiter(void 0, void 0, void 0, function* () {
    if (process.env.JSS_MODE === constants.JSS_MODE.DISCONNECTED) {
        return null;
    }
    const params = rendering.params || {};
    const result = yield fetchBYOCComponentServerProps(params);
    return result;
});
export default BYOCWrapper;
